import {
  LayoutDashboard,
  FileText,
  BarChart3,
  ListChecks,
  Box,
  Settings,
  HelpCircle,
  type LucideIcon,
} from 'lucide-react';

export interface NavItemConfig {
  path: string;
  labelKey: string;
  icon: LucideIcon;
  /** Hidden once the CAD feature flag resolves to false. */
  requiresCad?: boolean;
  /** Hidden once the per-tenant design verification flag resolves to false (#1214). */
  requiresDesignVerification?: boolean;
}

export interface NavSectionConfig {
  id: string;
  /** Small-caps heading in the expanded rail; the primary section has none. */
  labelKey?: string;
  items: NavItemConfig[];
}

export const NAV_SECTIONS: NavSectionConfig[] = [
  {
    id: 'primary',
    items: [
      { path: '/dashboard', labelKey: 'navigation.dashboard', icon: LayoutDashboard },
      { path: '/documents', labelKey: 'navigation.documents', icon: FileText },
    ],
  },
  {
    id: 'workspace',
    labelKey: 'navigation.workspaceSection',
    items: [
      { path: '/drbfm', labelKey: 'navigation.drbfm', icon: BarChart3 },
      {
        path: '/verification',
        labelKey: 'navigation.verification',
        icon: ListChecks,
        requiresDesignVerification: true,
      },
      { path: '/cad-viewer', labelKey: 'navigation.cadViewer', icon: Box, requiresCad: true },
    ],
  },
];

export const NAV_FOOTER_SECTION: NavSectionConfig = {
  id: 'footer',
  items: [
    { path: '/settings', labelKey: 'navigation.settings', icon: Settings },
    { path: '/help', labelKey: 'navigation.help', icon: HelpCircle },
  ],
};

export const USER_MENU_ITEMS: NavItemConfig[] = [
  { path: '/settings', labelKey: 'navigation.settings', icon: Settings },
];
